import 'select2/dist/js/select2.full.min'

// Help center search
$('.search-section__search-input').select2({
    width: '280px',
    placeholder: "Search SimplyBook.me",
    ajax: {
        url: 'https://help.simplybook.me/api.php',
        data: function (params) {
            return {
                action: "opensearch",
                search: params.term,
                limit: "10",
                namespace: "0",
                format: "json"
            }
        },
        processResults: function (data) {
            var results = [];
            for (let i in data[1]) {
                results.push({
                    id: data[3][i],
                    text: data[1][i]
                })
            }
            return {
                results: results
            };
        },
        dataType: 'json'
    }
});

$('.search-section__search-input').on('select2:select', function (e) {
    var data = e.params.data;
    window.open(data.id);
});